import { Injectable } from '@angular/core';
import { StorageService } from '../../services/storage/storage.service';
import { StorageKeyEnum } from '../../services/storage/enum/storage-key.enum';
import { GeneratedQuickQuoteModel } from '../quick-quote/model/quick-quote-model';

@Injectable({
  providedIn: 'root'
})
export class ConsumerStorageQuickQuoteService {
  constructor(private readonly storage: StorageService) {}

  /**
   * Gets the Quick Quote data from the localstorage.
   */
  get generatedQuickQuote(): GeneratedQuickQuoteModel {
    const data: string = this.storage.getValue(StorageKeyEnum.GENERATED_QUICK_QUOTE);
    return data ? JSON.parse(data) : null;
  }

  /**
   * Sets the Quick Quote data to the localstorage.
   */
  set generatedQuickQuote(value: GeneratedQuickQuoteModel) {
    this.storage.saveValue(StorageKeyEnum.GENERATED_QUICK_QUOTE, value ? JSON.stringify(value) : null);
  }

  /**
   * Gets the Quick Quote id from the localstorage.
   */
  get quickQuoteId(): string {
    return this.storage.getValue(StorageKeyEnum.QUICK_QUOTE_ID);
  }

  /**
   * Sets the Quick Quote id to the localstorage.
   */
  set quickQuoteId(value: string | null) {
    if (value) {
      this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_ID, value);
    } else {
      this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_ID, null);
    }
  }

  /**
   * Gets the Quick Quote stage from the localstorage.
   */
  get quickQuoteStage(): string {
    return this.storage.getValue(StorageKeyEnum.QUICK_QUOTE_STAGE);
  }

  /**
   * Sets the Quick Quote stage to the localstorage.
   */
  set quickQuoteStage(value: string | null) {
    if (value) {
      this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_STAGE, value);
    } else {
      this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_STAGE, null);
    }
  }

  /**
   * Gets the Quick Quote event step from the localstorage.
   */
  get quickQuoteEventStep(): string {
    return this.storage.getValue(StorageKeyEnum.QUICK_QUOTE_EVENT_STEP);
  }

  /**
   * Sets the Quick Quote event step to the localstorage.
   */
  set quickQuoteEventStep(value: string | null) {
    if (value) {
      this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_EVENT_STEP, value);
    } else {
      this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_EVENT_STEP, null);
    }
  }

  /**
   * Gets the generated external application ID from the localstorage.
   */
  get generatedExternalApplicationId(): string {
    return this.storage.getValue(StorageKeyEnum.GENERATED_EXTERNAL_APPLICATION_ID);
  }

  /**
   * Sets the generated external application ID to the localstorage.
   */
  set generatedExternalApplicationId(value: string | null) {
    if (value) {
      this.storage.saveValue(StorageKeyEnum.GENERATED_EXTERNAL_APPLICATION_ID, value);
    } else {
      this.storage.saveValue(StorageKeyEnum.GENERATED_EXTERNAL_APPLICATION_ID, null);
    }
  }

  /**
   * Clears all Quick Quote data from storage.
   */
  clearQuickQuoteData(): void {
    this.storage.saveValue(StorageKeyEnum.GENERATED_QUICK_QUOTE, null);
    this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_EVENT_STEP, null);
    this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_STAGE, null);
    this.storage.saveValue(StorageKeyEnum.QUICK_QUOTE_ID, null);
  }

  get quickQuoteReference(): string | undefined {
    const generatedQuickQuote = this.generatedQuickQuote;
    return generatedQuickQuote?.request?.salesforceCaseId;
  }
}
